<script lang="ts">
  import loadingStore from '@/pages/preview/loading-store';
  import SidebarModules from './SidebarModules.svelte';
  import ActionBar from './ActionBar.svelte';
  import {horizontalSlide} from '../../transitions/transitions';
  import PopoverView from '../../lib/editor/PopoverView/PopoverView.svelte';
  import Loader from '../loader/Loader.svelte';
  import VideoClip from './VideoClip.svelte';
  import AdvanceSidebarModules from './AdvanceSidebarModules.svelte';
  import ImageManager from './Modules/ImageManager/ImageManager.svelte';
  import {user} from '../../store';
  const animationDelay = 500;
  const isAdmin = window.uData && window.uData.is_admin;
</script>

<div
  in:horizontalSlide
  class="relative z-30 flex h-full flex-col gap-4 overflow-hidden border-r border-gray-300 shadow-md"
  id="preview-sidebar"
>
  <PopoverView />
  {#if $loadingStore}
    <div class="h-full w-full px-6">
      <div
        class="mb-2 mt-6 h-4 animate-pulse rounded-lg bg-zinc-300"
        style="width: 80px; animation-delay: {animationDelay * 0}ms;"
      ></div>
      <div class="grid w-full gap-4">
        <div class="flex h-12 w-full justify-between">
          <div
            class="my-2 h-full w-32 animate-pulse rounded-xl bg-zinc-300"
            style="animation-delay: {animationDelay * 1}ms;"
          ></div>
          <div
            class="my-2 h-full w-8 animate-pulse rounded-xl bg-zinc-300"
            style="animation-delay: {animationDelay * 1}ms;"
          ></div>
        </div>
        <div class="w-full">
          <div
            class="mb-2 mt-6 h-4 animate-pulse rounded-lg bg-zinc-300"
            style="width: 96px; animation-delay: {animationDelay * 3}ms;"
          ></div>
          <div
            class="mb-2 mt-6 h-12 w-full animate-pulse rounded-lg bg-zinc-300"
            style="animation-delay: {animationDelay * 3}ms;"
          ></div>
        </div>
        <div class="flex h-12 w-full justify-between">
          <div
            class="my-2 h-full w-28 animate-pulse rounded-lg bg-zinc-300"
            style="animation-delay: {animationDelay * 4}ms;"
          ></div>
          <div
            class="my-2 h-full w-48 animate-pulse rounded-lg bg-zinc-300"
            style="animation-delay: {animationDelay * 4}ms;"
          ></div>
        </div>
        <div class="flex h-12 w-full justify-between">
          <div
            class="my-2 h-full w-28 animate-pulse rounded-lg bg-zinc-300"
            style="animation-delay: {animationDelay * 5}ms;"
          ></div>
          <div
            class="my-2 h-full w-48 animate-pulse rounded-lg bg-zinc-300"
            style="animation-delay: {animationDelay * 5}ms;"
          ></div>
        </div>
        <div class="flex h-12 w-full justify-between">
          <div
            class="my-2 h-full w-16 animate-pulse rounded-lg bg-zinc-300"
            style="animation-delay: {animationDelay * 6}ms;"
          ></div>
          <div
            class="my-2 h-full w-48 animate-pulse rounded-lg bg-zinc-300"
            style="animation-delay: {animationDelay * 6}ms;"
          ></div>
        </div>
        <div class="flex h-12 w-full justify-between">
          <div
            class="my-2 h-full w-14 animate-pulse rounded-lg bg-zinc-300"
            style="animation-delay: {animationDelay * 7}ms;"
          ></div>
          <div
            class="my-2 h-full w-48 animate-pulse rounded-lg bg-zinc-300"
            style="animation-delay: {animationDelay * 7}ms;"
          ></div>
        </div>
        <div class="flex h-12 w-full justify-between">
          <div
            class="my-2 h-full w-28 animate-pulse rounded-lg bg-zinc-300"
            style="animation-delay: {animationDelay * 8}ms;"
          ></div>
          <div
            class="my-2 h-full w-12 animate-pulse rounded-lg bg-zinc-300"
            style="animation-delay: {animationDelay * 8}ms;"
          ></div>
        </div>
        <div class="flex h-12 w-full justify-between">
          <div
            class="my-2 h-full w-14 animate-pulse rounded-lg bg-zinc-300"
            style="animation-delay: {animationDelay * 9}ms;"
          ></div>
          <div class="flex gap-4">
            <div
              class="my-2 h-full w-10 animate-pulse rounded-lg bg-zinc-300"
              style="animation-delay: {animationDelay * 9}ms;"
            ></div>
            <div
              class="my-2 h-full w-10 animate-pulse rounded-lg bg-zinc-300"
              style="animation-delay: {animationDelay * 9}ms;"
            ></div>
            <div
              class="my-2 h-full w-10 animate-pulse rounded-lg bg-zinc-300"
              style="animation-delay: {animationDelay * 9}ms;"
            ></div>
            <div
              class="my-2 h-full w-10 animate-pulse rounded-lg bg-zinc-300"
              style="animation-delay: {animationDelay * 9}ms;"
            ></div>
          </div>
        </div>
      </div>
      <div
        class="mb-2 mt-6 h-2 animate-pulse rounded-lg bg-zinc-300"
        style="width: 80px; animation-delay: {animationDelay * 10}ms;"
      ></div>
      <div class="w-full">
        <div
          class="mb-2 mt-6 h-4 animate-pulse rounded-lg bg-zinc-300"
          style="width: 96px; animation-delay: {animationDelay * 11}ms;"
        ></div>
        <div
          class="mb-2 mt-6 h-8 w-full animate-pulse rounded-lg bg-zinc-300"
          style="animation-delay: {animationDelay * 11}ms;"
        ></div>
      </div>
      <div
        class="mb-2 mt-6 h-2 animate-pulse rounded-lg bg-zinc-300"
        style="width: 80px; animation-delay: {animationDelay * 12}ms;"
      ></div>
      <div class="w-full">
        <div
          class="mb-2 mt-6 h-4 animate-pulse rounded-lg bg-zinc-300"
          style="width: 96px; animation-delay: {animationDelay * 13}ms;"
        ></div>
        <div
          class="mb-2 mt-6 h-8 w-full animate-pulse rounded-lg bg-zinc-300"
          style="animation-delay: {animationDelay * 13}ms;"
        ></div>
      </div>
    </div>
  {:else}
    <div class="flex h-full flex-col overflow-y-scroll px-5" id="sidebarContent">
      <div class="w-full">
        <div class="flex items-center gap-1 px-4 pb-2 pb-2 pt-8 font-bold text-zinc-900">
          <span>Quick Edit</span>
        </div>
        <ActionBar />
        <SidebarModules />
      </div>

      <div class="px-4 pb-6">
        <hr />
      </div>

      <div class="px-4 pb-12 pt-6">
        <div class="flex items-center gap-1 pb-2 font-bold text-zinc-900">
          <!-- <i class="fa-solid fa-video"></i> -->
          <span>Video Clip</span>
        </div>
        <VideoClip />
      </div>
      <div class="px-4 pb-8">
        <hr />
      </div>
      <div class="px-4 pb-8 pt-6">
        <!-- <div class="flex items-center font-semibold gap-1 pb-4 text-zinc-500 text-xs">
					<i class="fa-light fa-image"></i>
					<span>Photos</span>
				</div> -->
        <div class="flex items-center gap-1 pb-2 font-bold text-zinc-900">
          <!-- <i class="fa-solid fa-video"></i> -->
          <span>Photos</span>
        </div>
        <ImageManager />
      </div>
      <div class="px-4 pb-6">
        <hr />
      </div>

      <div class="px-4 py-6">
        <div class="flex items-center gap-1 pb-4 text-sm font-bold text-zinc-900">
          <span>Text</span>
        </div>
        <AdvanceSidebarModules />
      </div>
    </div>
  {/if}
</div>

<style lang="postcss" global>
  #sidebarContent::-webkit-scrollbar {
    @apply absolute w-1 rounded-full bg-slate-100 p-1;
  }

  #sidebarContent::-webkit-scrollbar-track {
    @apply rounded-full shadow-gray-500;
  }
  #sidebarContent::-webkit-scrollbar-thumb {
    @apply rounded-full bg-gray-400;
  }
  #sidebarContent::-webkit-scrollbar-thumb:hover {
    @apply rounded-full bg-gray-500;
  }
  #sidebarContent {
    /* color : #606060; */
  }
  #preview-sidebar {
    min-width: 450px;
    max-width: 450px;
  }
  .sBtn {
    @apply w-44 cursor-pointer rounded-lg bg-white px-4 py-2 hover:bg-opacity-50;
    font-size: 1.12rem;
  }

  .sBtn .fa {
    font-size: 0.8rem;
  }

  .sBtn.light {
    @apply bg-gray-100 py-1 hover:bg-gray-200;
  }

  .sBtn.selected {
    @apply bg-gray-300 font-extrabold;
  }

  .dot {
    @apply absolute bg-primary;
    height: 10px;
    width: 10px;
    background-color: #e25c6c;
    border-radius: 50%;
    display: inline-block;
    cursor: pointer;
  }

  ::-webkit-scrollbar {
    @apply w-2 rounded-full bg-slate-100 p-1;
  }
  ::-webkit-scrollbar-track {
    @apply rounded-full shadow-gray-500;
  }
  ::-webkit-scrollbar-thumb {
    @apply rounded-full bg-gray-400;
  }
  ::-webkit-scrollbar-thumb:hover {
    @apply rounded-full bg-gray-500;
  }
</style>
